import o from"./index.module.scss.js";const s=o;export{s as CheckboxTheme};
//# sourceMappingURL=index.js.map
